<template>
    <BlockEditoCreateSocialNetwork>
      <template #checkboxUseNetwork>
        <el-tooltip class="ml-1" placement="top-start" :content="$t('socialNetworkPosts.messageDisabledCheckbox')" :disabled="!(post.instagram.alreadyPublished || isDraftButtonDisabled)">
          <el-checkbox v-model="facebookChecked" @change="checkPublishButtonState" :disabled="post.instagram.alreadyPublished || isDraftButtonDisabled"></el-checkbox>
        </el-tooltip>
      </template>
      <template #iconAndTitleNetwork>
        <img
            alt=""
            :src="require(`@/assets/facebook-logo-5-1.png`)"
            width="20"
            style="padding-bottom: 8px;margin-right:15px;"
        />Facebook
      </template>
      <template #customize v-if="facebookChecked && !post.facebook.alreadyPublished && user.haveFacebookEdito">
        {{ $t('socialPosts.create.customizePost') }}<el-switch v-model="customFacebook" @change="confirmCustomOff" style="padding-left: 15px;"></el-switch>
      </template>
      <template #alreadyPublished v-if="post.facebook.alreadyPublished">
        <div v-html="$t('socialPosts.create.alreadyPublished')"></div>
      </template>
      <template #content>
        <div v-if="facebookChecked && user.haveFacebookEdito">
          <el-row style="margin-top: 20px">
            <el-col>
              <div v-if="!post.initial.libelle">
                <el-tooltip class="item" effect="dark" :content="$t('socialPosts.create.IAButtonDisabled')" placement="bottom">
                  <el-button  size="mini" type="success" @click="openModalIA()" :disabled="!post.initial.libelle" v-if="customFacebook" style="margin-bottom: 15px;">{{$t('socialPosts.create.redactWithAi')}}</el-button>
                </el-tooltip>
              </div>
              <div v-else>
                <el-button  size="mini" type="success" @click="openModalIA()" :disabled="post.facebook.alreadyGeneratedAI" style="margin-bottom: 15px;" v-if="customFacebook">{{$t('socialPosts.create.redactWithAi')}}</el-button>
              </div>
              <el-form-item prop="texteInputFacebook">
                <div class="textarea-with-emojis" >
                  <el-input :rows="8"
                            type="textarea"
                            v-model="facebookInputText"
                            :disabled="checkDisabled"
                            ref="textareaPostEditoFacebook">
                  </el-input>
                  <div>
                    <Emoji v-if="customFacebook" @addEmoji="addEmoji($event)" class="box-emojis"/>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="24">
              <el-form-item label="Média" v-if="getStatusMediaPost.hasPhotos || getStatusMediaPost.hasVideoUrl || getStatusMediaPost.hasVideoUpload">
<!--                <el-checkbox :label="$t('socialPosts.create.dontuseAnotherPicture')" :disabled="checkDisabled" v-model="post.facebook.useAnotherPicture"></el-checkbox>-->
                <div v-if="post && post.photos.length > 0">
                  <PostPhotosCustom network-name="facebook" :photos="post.photos"/>
                </div>
                <div v-if="post && post.photos.length === 0 && getStatusMediaPost.hasPhotos">
                  <!-- Miroir des photos uploadées depuis PostEditoCreatePublicationInitiale -->
                  <el-row :gutter="50" v-if="post.initial.pictures && post.initial.pictures.length > 0">
                    <el-col :span="8" v-for="photo in post.initial.pictures" :key="photo.url" style="padding-bottom: 20px" v-if="photo && photo.url">
                      <ubi-card :published="true" full-width class="uploaded-images-preview">
                        <img :key="photo.url" :src="photo.url" height="215" alt="" class="uploaded-image"/>
                      </ubi-card>
                    </el-col>
                  </el-row>
                </div>
                <el-row  v-if="getStatusMediaPost.hasVideoUrl && !getStatusMediaPost.hasVideoUpload">
                  <el-col :span="24">
                    <el-form-item :label="$t('posts.networks.videoTitre')" :error="inputError">
                      <el-input v-model="linkToVideoInput" @change="updateLinkToVideo" type="url" :disabled="checkDisabled"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <upload-video
                  v-if="getStatusMediaPost.hasVideoUpload"
                  :post-id="post.id"
                  network-name="initial"
                  :none-display-button-remove="true"
                />

<!--                <post-edito-photos-upload-->
<!--                  v-if="post.facebook.useAnotherPicture"-->
<!--                  :post="post"-->
<!--                  network="facebook"-->
<!--                  :desactiver-champ="checkDisabled"-->
<!--                >-->
<!--                </post-edito-photos-upload>-->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="24">
              <el-form-item :label="$t('socialPosts.create.actionButton')">
                <el-select v-model="post.facebook.actionButton" :placeholder="$t('socialPosts.create.typeOfActionButton')" :disabled="checkDisabled">
                  <el-option value="LEARN_MORE" :label="$t('socialPosts.create.learnMore')">{{$t('socialPosts.create.learnMore')}}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="24">
              <el-form-item :label="$t('socialPosts.create.urlActionButton')" prop="eventLinkInput">
                <el-input v-model="post.facebook.urlAction" :disabled="checkDisabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="24">
              <el-form-item label="UTM">
                <div style="margin-top: -38px; margin-left: 40px">
                  <el-tooltip class="item" effect="dark" :content="$t('socialPosts.create.tooltipGoogleUTM')"
                              placement="bottom">
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
                <el-input v-model="post.facebook.UTM" :disabled="checkDisabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-if="facebookChecked && !user.haveFacebookEdito">
          <div style="margin-top: 8px;" v-html="$t('socialPosts.diffusionDisabled', { networkName: 'Facebook'})"></div>
          <hr/>
          <div class="text-right">
            <el-row>
              <el-button type="primary" @click="sendMail('Facebook')">{{ $t('socialPosts.iWantToEnableThisNetwork') }}</el-button>
            </el-row>
          </div>
        </div>
      </template>
    </BlockEditoCreateSocialNetwork>
</template>

<script>
import Emoji from '@/components/emojis/Emoji'
import PostEditoPhotosUpload from '@/pages/socialNetworks/components/PostEditoPhotosUpload'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import BlockEditoCreateSocialNetwork from '@/pages/socialNetworks/components/BlockEditoCreateSocialNetwork'
import TeasingCalendar from '@/pages/calendar/components/TeasingCalendar.vue'
import { $t } from '@/i18n'
import UploadVideo from '@/components/Upload/UploadVideo.vue'
import BoxInfos from '@/components/ui/BoxInfos.vue'
import PostPhotosCustom from '@/pages/posts/SocialMedia/components/PostPhotosCustom.vue'
import UbiCard from '@/components/Card'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import PostEditoValidationMixin from '@/mixins/PostEditoValidationMixin'

export default {
  name: 'PostEditoCreateFacebook',
  components: {
    PostPhotosCustom,
    BoxInfos,
    UploadVideo,
    Emoji,
    PostEditoPhotosUpload,
    BlockEditoCreateSocialNetwork,
    UbiCard
  },
  props: ['post'],
  mixins: [PostEditoValidationMixin],
  data () {
    return {
      checkDisabled: true,
      inputError: ''
    }
  },
  watch: {
    customFacebook: function (custom) {
      if (custom) {
        this.checkDisabled = false
      } else {
        this.checkDisabled = true
      }
      return this.checkDisabled
    }
  },
  computed: {
    ...mapGetters('socialPostsCreationPostEditorial', ['getStatusMediaPost']),
    ...mapState('socialPostsCreationPostEditorial', ['customFacebook', 'facebookChecked']),
    facebookChecked: {
      get () {
        return this.$store.getters['socialPostsCreationPostEditorial/getFacebookChecked']
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/setFacebookChecked', value)
      }
    },
    customFacebook: {
      get () {
        return this.$store.getters['socialPostsCreationPostEditorial/getCustomFacebook']
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/setCustomFacebook', value)
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    linkToVideoInput: {
      get () {
        return this.$store.state.socialPostsCreationPostEditorial.post.facebook.linkToVideo
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/updateInputVideoFacebook', value)
      }
    },
    facebookInputText: {
      get () {
        return this.$store.state.socialPostsCreationPostEditorial.post.facebook.inputText
      },
      set (value) {
        // Si on est en mode custom, utiliser la mutation spécifique Facebook
        if (this.customFacebook) {
          this.$store.commit('socialPostsCreationPostEditorial/updateInputTextFacebook', value)
        } else {
          // Sinon, utiliser la mutation générale qui synchronise depuis initial
          this.$store.commit('socialPostsCreationPostEditorial/updateInputTextInitial', value)
        }
      }
    }
  },
  methods: {
    ...mapMutations('socialPostsCreationPostEditorial',
      ['setCustomFacebook',
        'setFacebookChecked',
        'setModalIA',
        'checkPublishButtonState',
        'setNetworkClicked']),
    openModalIA () {
      this.setNetworkClicked('facebook')
      this.setModalIA(true)
    },
    updateLinkToVideo (value) {
      this.inputError = ''
      if (!value || this.urlIsValid(value)) {
        this.$store.commit('socialPostsCreationPostEditorial/checkDraftButtonState', value)
        this.$store.commit('socialPostsCreationPostEditorial/checkPublishButtonState', value)
      } else {
        this.inputError = $t('posts.networks.videoUrlError')
        this.$emit('updateValue', 'setError', this.inputError)
        this.$store.commit('socialPostsCreationPostEditorial/setPublishButtonAvailable', true)
        this.$store.commit('socialPostsCreationPostEditorial/setDraftButtonAvailable', true)
        this.$message({ message: $t('posts.networks.videoUrlError'), type: 'error', duration: 4000 })
        return false
      }
    },
    urlIsValid (urlString) {
      let isValid = false
      try {
        const urlVideo = new URL(urlString)
        isValid = (
          ((urlVideo.protocol === 'http:') || (urlVideo.protocol === 'https:')) &&
          (urlVideo.hostname.indexOf('youtube') === -1) &&
          (urlVideo.hostname.indexOf('dailymotion') === -1)
        )
      } catch (_) {
      }
      return isValid
    },
    addEmoji (emoji) {
      const insertText = emoji
      if (!insertText.length) {
        return
      }
      const textarea = this.$refs.textareaPostEditoFacebook.$el.querySelector('.el-textarea__inner')
      let cursorIndex = textarea.selectionEnd
      if (textarea.innerHTML === '' && !this.facebookInputText) {
        textarea.innerHTML += insertText
      }
      if (this.facebookInputText) {
        this.facebookInputText = this.facebookInputText.substring(0, cursorIndex) + insertText + this.facebookInputText.substring(cursorIndex)
      } else {
        this.facebookInputText = insertText
      }

      setTimeout(() => {
        cursorIndex += insertText.length
        textarea.selectionStart = textarea.selectionEnd = cursorIndex
      }, 10)
    },
    sendMail (network) {
      this.$store.dispatch('socialPostsCreationPostEditorial/sendEmailEnableNetwork', network)
    },
    confirmCustomOff (value) {
      if (this.customFacebook === false) {
        this.$store.commit('socialPostsCreationPostEditorial/setModalStopCustom', true)
        this.$store.commit('socialPostsCreationPostEditorial/setStopCustomNetwork', 'facebook')
        this.inputError = ''
        this.$store.commit('socialPostsCreationPostEditorial/checkDraftButtonState', value)
        this.$store.commit('socialPostsCreationPostEditorial/checkPublishButtonState', value)
      }
    },
  },
  beforeMount () {
    if (this.customFacebook) {
      this.checkDisabled = false
    } else {
      this.checkDisabled = true
    }

    if (this.post.google.alreadyPublished) {
      this.checkDisabled = false
    } else {
      this.checkDisabled = true
    }
  }
}
</script>

<style scoped>
.textarea-with-emojis {
  position: relative;
}

.box-emojis {
  position: absolute;
  bottom: 0px;
  right: -5px;
  z-index: 3;
}
.el-form--label-top .el-form-item .el-form-item__label {
  color: #184a56;
  line-height: 1.5;
  font-weight: bold;
}

.uploaded-images-preview {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0;
  margin-left: 0;
}

.uploaded-image {
  margin: 0;
  padding: 0;
  max-width: 180px;
  object-fit: cover;
}
</style>
